import React from "react";

import { css } from "emotion";

import styled from "react-emotion";

import { color } from "styled-system";

import FontAwesomeIcon from "@fortawesome/react-fontawesome";

import { colors } from "src/styles";

import ArrowIcon from "./Arrow";
import ArrowInCircleIcon from "./ArrowInCircle";
import MenuIcon from "./Menu";
import FacebookIcon from "./Facebook";
import GooglePlusIcon from "./GooglePlus";
import LinkedInIcon from "./LinkedIn";
import RSSIcon from "./RSS";
import TwitterIcon from "./Twitter";

const iconStyles = ({ size }) => css`
  width: ${size}px;
  height: ${size}px;
`;

export const wrapIcon = Icon => styled(Icon)`
  ${iconStyles};
  ${color};
`;

export const Arrow = wrapIcon(ArrowIcon);

export const ArrowInCircle = wrapIcon(ArrowInCircleIcon);

export const Menu = wrapIcon(MenuIcon);

export const Facebook = wrapIcon(FacebookIcon);
export const GooglePlus = wrapIcon(GooglePlusIcon);
export const LinkedIn = wrapIcon(LinkedInIcon);
export const Twitter = wrapIcon(() =>
  TwitterIcon({
    width: "15",
    height: "15",
  })
);
export const RSS = wrapIcon(RSSIcon);

export const FontAwesome = ({ color, size, style, ...props }) => (
  <FontAwesomeIcon
    style={{
      width: size,
      height: size,
      color: colors[color],
    }}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/icons/index.js